module.exports = {
  THRESHOLDS_EDIT_REQUEST: 'THRESHOLDS_EDIT_REQUEST',
  THRESHOLDS_EDIT_SUCCESS: 'THRESHOLDS_EDIT_SUCCESS',
  THRESHOLDS_EDIT_FAILURE: 'THRESHOLDS_EDIT_FAILURE',
};
